if (!customElements.get('product-description-readmore')) {
  customElements.define(
    'product-description-readmore',
    class ProductDescriptionReadmore extends HTMLElement {
      connectedCallback() {
        if (!this.classList.contains('is-collapsible')) return;

        this.button = this.querySelector('.product-description-readmore__toggle');
        this.labelMore = this.querySelector('.product-description-readmore__label-more');
        this.labelLess = this.querySelector('.product-description-readmore__label-less');

        if (!this.button) return;

        this.button.addEventListener('click', this.onToggle.bind(this));
      }

      onToggle() {
        const willExpand = !this.classList.contains('is-expanded');
        this.classList.toggle('is-expanded', willExpand);
        this.classList.toggle('is-collapsed', !willExpand);
        this.updateLabels(willExpand);
      }

      updateLabels(expanded) {
        if (this.labelMore) this.labelMore.classList.toggle('hidden', expanded);
        if (this.labelLess) this.labelLess.classList.toggle('hidden', !expanded);
      }
    }
  );
}
